import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 8h-4v8h4","key":"svg-0"}],["path",{"d":"M10 12h2.5","key":"svg-1"}]]

const IconLetterESmall = createReactComponent('outline', 'letter-e-small', 'LetterESmall', __iconNode);

export default IconLetterESmall;